module.exports = __webpack_public_path__ + "img/logo-gradual.aae95925.png";